<template>
  <ul>
    <li v-for="row of rows" :key="row.id" class="mb-b">
      <ul
        class="grid gap-6"
        :class="{
          'md:grid-cols-2': row.fields.length === 2,
          'md:grid-cols-3': row.fields.length === 3,
          'md:grid-cols-4': row.fields.length === 4,
          'md:grid-cols-5': row.fields.length === 5,
          'md:grid-cols-6': row.fields.length === 6,
        }"
      >
        <li v-for="(field, fieldIndex) of row.fields" :key="fieldIndex">
          <component :is="fieldComponent(field)" :settings="settings" :field="field" />
        </li>
      </ul>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { fieldComponentName } from '~/assets/formie'

interface Props {
  settings: Record<string, any>
  rows: Array<{ id: number; fields: any[] }>
}

defineProps<Props>()

const fieldComponent = (field) => {
  /** @see https://github.com/rollup/plugins/tree/master/packages/dynamic-import-vars */
  return defineAsyncComponent(() => import(`./Formie/${fieldComponentName(field)}.vue`))
}
</script>
